export const mapStyle = [{
  'featureType': 'land',
  'elementType': 'geometry',
  'stylers': {
    'color': '#081734'
  }
},
{
  'featureType': 'building',
  'elementType': 'geometry',
  'stylers': {
    'color': '#04406F'
  }
},
{
  // 调整建筑物标签是否可视
  'featureType': 'building',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  // 调整高速道路颜色
  'featureType': 'highway',
  'elementType': 'geometry',
  'stylers': {
    'color': '#015B99'
  }
},
{
  // 调整高速名字是否可视
  'featureType': 'highway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  // 调整一些干道颜色
  'featureType': 'arterial',
  'elementType': 'geometry',
  'stylers': {
    'color': '#003051'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'green',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'water',
  'elementType': 'geometry',
  'stylers': {
    'color': '#044161'
  }
},
{
  // 调整地铁颜色
  'featureType': 'subway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#003051'
  }
},
{
  'featureType': 'subway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'railway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'railway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  // 调整所有的标签的边缘颜色
  'featureType': 'all',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#081734'
  }
},
{
  // 调整所有标签的填充颜色
  'featureType': 'all',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#081734'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'local',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'local',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'subway',
  'elementType': 'geometry',
  'stylers': {
    'lightness': -65
  }
},
{
  'featureType': 'railway',
  'elementType': 'all',
  'stylers': {
    'lightness': -40
  }
},
{
  'featureType': 'boundary',
  'elementType': 'geometry',
  'stylers': {
    'color': '#8b8787',
    'weight': '1',
    'lightness': -29
  }
}]



// WEBPACK FOOTER //
// ./src/map_style.js